import { combineReducers } from "redux";

import { sessionReducer } from "./session/reducers";
import { protocolWizardReducer } from './create-protocol-wizard/reducers';
import { mailProtocolWizardReducer } from './mail-protocol-wizard/reducers';
import { appNavigationReducer } from './app-navigation/reducers';
import { sendMailReducer } from './send-mail/reducers';

import sessionActions from './session/actions';
import protocolWizardActions from './create-protocol-wizard/actions';
import mailProtocolWizardActions  from './mail-protocol-wizard/actions';
import appNavigationActions from './app-navigation/actions';
import sendMailActions from './send-mail/actions';

const reduxActions = {
    sessionActions,
    protocolWizardActions,
    mailProtocolWizardActions,
    appNavigationActions,
    sendMailActions
}
export { reduxActions }

export const rootReducer = combineReducers({
    sessionReducer: sessionReducer,
    protocolWizardReducer: protocolWizardReducer,
    mailProtocolWizardReducer: mailProtocolWizardReducer,
    appNavigationReducer: appNavigationReducer,
    sendMailReducer: sendMailReducer
})

export type RootState = ReturnType<typeof rootReducer>